import { c as _c } from "react/compiler-runtime";
import type { Cents } from '@systemeio/types';
import { useControlledSwr } from '@systemeio/util';
import { useFetch } from 'shared/hooks/use-fetch';
import { RequestMethodsEnum } from 'shared/hooks/use-fetch/types';
import useUser from 'shared/hooks/use-user';
const TOTAL_REVENUE_LIMIT_API = '/api/dashboard/customer/user-plan/user-resources/total-revenue';
interface TotalRevenueLimitInterface {
  current: Cents;
  maxLimit: Cents | null;
}
export const useTotalRevenueLimit = () => {
  const $ = _c(6);
  const {
    user,
    isFreemium
  } = useUser();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      method: RequestMethodsEnum.get
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const {
    fetcher
  } = useFetch(t0);
  let t1;
  if ($[1] !== isFreemium || $[2] !== user) {
    t1 = () => {
      if (user && isFreemium) {
        return TOTAL_REVENUE_LIMIT_API;
      }
      return null;
    };
    $[1] = isFreemium;
    $[2] = user;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  const {
    data: totalRevenueLimit
  } = useControlledSwr(t1, fetcher);
  let t2;
  if ($[4] !== totalRevenueLimit) {
    t2 = {
      totalRevenueLimit
    };
    $[4] = totalRevenueLimit;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};